import styled from 'styled-components'

export const Progress = styled.div<{
  width?: any
}>`
  width: ${(props) => (props.width ? props.width : '10%')};
  background-color: #5766ff;
  color: #5766ff;
  opacity: 1;
  height: 5px;
`

export const JoinContestWrapper = styled.div`
  margin: 6rem 20px 0 20px;
  /* height: 90vh; */

  .withdraw_component {
    position: absolute;
    top: 30px;
    left: 20px;
  }

  .opacity {
    opacity: 0.4;
    pointer-events: none;
  }

  .name {
    font-style: normal;
    font-weight: 600;
    font-size: ${({ theme }) => theme.fontSize.xl};
    /* line-height: 48px; */
    /* margin: 0; */
    color: ${({ theme }) => theme.colors.black};
  }

  .amount {
    display: flex;
    justify-content: space-between;
  }

  .amount_to_save {
    font-style: normal;
    font-weight: 700;
    font-size: ${({ theme }) => theme.fontSize.x5};
    color: ${({ theme }) => theme.colors.navyBlue2};
  }

  .progress_number {
    font-weight: 400;
    font-size: ${({ theme }) => theme.fontSize.x8};
    color: ${({ theme }) => theme.colors.navyBlue2};
  }

  .other_details {
    display: flex;
    justify-content: space-between;
  }

  .menu_container {
    margin-top: 1rem;
    height: 35vh;
  }

  .joined_contest_link {
    color: black;
  }

  .menu_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    border-bottom: 1px solid rgba(228, 228, 228, 0.3);
    padding-bottom: 10px;
  }

  .title {
    font-style: normal;
    font-weight: 600;
    font-size: ${({ theme }) => theme.fontSize.x5};
    color: ${({ theme }) => theme.colors.navyBlue};
    line-height: 20px;
  }

  .description {
    font-size: 13px;
    line-height: 18px;
    color: ${({ theme }) => theme.colors.contestPrimary};
  }

  .left {
    display: flex;
  }

  .arrow {
    color: ${({ theme }) => theme.colors.gray3};
    height: 15px;
    font-size: 2rem;
  }

  .text {
    padding-left: 20px;

    p {
      margin: 0;
      padding: 3px 0;
    }
  }
  .delete_contest_wrapper {
    margin: 0;
  }
  .top_up_container {
    margin-top: 4rem;
  }
`
